
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M12 1L14.4697 8.60081H22.4616L15.996 13.2984L18.4656 20.8992L12 16.2016L5.53436 20.8992L8.00402 13.2984L1.53838 8.60081H9.53035L12 1Z" fill="currentColor"></path></svg>';export default svg;
    